import { Notifications } from "@mantine/notifications";
import { IconFileText, IconHelp, IconSearch, IconSettings } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { NOTIFICATIONS_STACK_STYLE } from "#app/notifications";
import { PermissionsProvider } from "#app/PermissionsProvider";
import { ThemeProviderV2 } from "#app/theme/v2/ThemeProviderV2";
import { AppLayout } from "#components/templates/AppLayout/AppLayout";
import { Navbar } from "#components/templates/Navbar/Navbar";
import { NAV_ITEM_ICON_SIZE } from "#components/templates/Navbar/NavItem";
import { useLogout } from "#modules/auth/infra/useLogout";
import { useCompany } from "#modules/company/view/useCompany";
import { OptimizationInvalidationModal } from "#modules/optimizations/view/OptimizationInvalidationModal";
import { useUser } from "#modules/users/view/useUser";
import { formatFullName } from "#shared/helpers/formatFullName";
import { ROUTES } from "#shared/routes";

const NavbarConnected = () => {
  const { user, isLoading } = useUser();
  const { company, isLoading: isLoadingCompany } = useCompany();
  const { logout } = useLogout();
  const { t } = useTranslation();

  const TOP_NAV_ITEMS = [
    {
      icon: <IconFileText size={NAV_ITEM_ICON_SIZE} />,
      label: t("navigation.quoteRequests"),
      to: ROUTES.v2QuoteRequests,
    },
    {
      icon: <IconSearch size={NAV_ITEM_ICON_SIZE} />,
      label: t("navigation.search"),
      to: ROUTES.v2Search,
    },
  ];

  const BOTTOM_NAV_ITEMS = [
    {
      icon: <IconSettings size={NAV_ITEM_ICON_SIZE} />,
      label: t("navigation.settings"),
      to: ROUTES.v2Settings,
      disabled: true,
    },
    {
      icon: <IconHelp size={NAV_ITEM_ICON_SIZE} />,
      label: t("navigation.help"),
      to: ROUTES.v2Support,
      disabled: true,
    },
  ];

  return (
    <Navbar
      topItems={TOP_NAV_ITEMS}
      bottomItems={BOTTOM_NAV_ITEMS}
      isLoadingProfile={isLoading || isLoadingCompany}
      userName={formatFullName(user)}
      companyName={company?.name ?? ""}
      onLogout={logout}
    />
  );
};

export const AuthenticatedLayoutV2 = () => {
  return (
    <PermissionsProvider>
      <ThemeProviderV2>
        <Notifications position="bottom-right" style={NOTIFICATIONS_STACK_STYLE} />
        <AppLayout leftSection={<NavbarConnected />}>
          <Outlet />
        </AppLayout>
        <OptimizationInvalidationModal />
      </ThemeProviderV2>
    </PermissionsProvider>
  );
};
